<template>
  <div>
    <Form ref="formInline" inline :label-width="150" label-position="left">
      <Row type="flex" justify="space-between">
        <Col>
          <FormItem label="权限类型：">
            <Select v-model="otCtrl.powerType" clearable style="width: 300px;margin-right:30px" placeholder="">
              <Option v-for="(item, i) in TypeList" :key="i" :value="item.code" >{{ item.name1 }}</Option>
            </Select>
          </FormItem>
          <FormItem label="权限描述:">
            <Input v-model="otCtrl.powerDescribe" style="width: 300px;margin-right:30px"/>
          </FormItem>
          <Button @click="pageInfo.pageNo = 1,total = 0,getData()"><!-- 检索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
    <Table stripe border :columns="columns" :loading="loading" :data="dataTable">
    </Table>
    <div style="margin: 15px 0">
      <Page :total="total" style="float: left; margin-top: 15px" @on-change="pageChange"/>
      <Button type="primary" icon="md-add" style="float: right;" @click="addData()">新增</Button>
    </div>
    <Modal v-model="popShow" width="600" title="新增">
      <Form :modal="formItem" ref="formItem" :label-width="185" label-position="left" style="margin: 10px 40px 0 40px">
        <FormItem label="权限类型：">
          <Select v-model="formItem.powerType" clearable placeholder="">
            <Option v-for="(item, i) in TypeList" :key="i" :value="item.code" >{{ item.name1 }}</Option>
          </Select>
        </FormItem>
        <FormItem label="权限值：">
          <Input v-model="formItem.powerKey" />
        </FormItem>
        <FormItem label="权限描述">
          <Input v-model="formItem.powerDescribe" />
        </FormItem>
      </Form>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <div slot="footer">
        <Button @click="cancelLeaveData">取消</Button>
        <Button @click="saveLeaveData">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      formItem: {},
      columns: [
        // {
        //   title: "权限ID",
        //   key: "powerId",
        //   align: "center",
        // },
        {
          title: "权限类型",
          key: "powerType",
          align: "center",
          render: (h,params)=>{
            var powerType1 = ''
            this.TypeList ? this.TypeList.forEach((item,index)=>{
              if(item.code == params.row.powerType){
                powerType1 = item.name1
              }
            }):''
            return h("span", powerType1);
          },
        },
        {
          title: "权限值",
          key: "powerKey",
          align: "center",
        },
        {
          title: "权限描述",
          key: "powerDescribe",
          align: "center",
        },
      ],
      dataTable: [],
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
      },
      total: 0,
      TypeList: [],
      spinShow: false,
      loading: false,
      otCtrl: {},
      popShow: false,
    };
  },
  created() {
    this.getData()
    this.getLabel()
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    getData() {
      this.loading = true;
      let obj = {
        powerType: this.otCtrl.powerType,
        powerDescribe: this.otCtrl.powerDescribe,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
      };
      axios.post("/MPowerMaster/selectMPowerMaster", obj).then((res) => {
        this.loading = false;
        if (res) {
          this.dataTable = res.data;
          this.total = Number(res.pageInfo.total);
        }
      });
    },
    addData() {
      this.formItem = {}
      this.popShow = true;
    },
    getLabel() {
      axios.post("/MPowerMaster/selectMPowerMasterLabel", {}).then((res) => {
        this.TypeList = res.TypeList;
      });
    },
    saveLeaveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        onOk: () => {
          this.submitSave();
        },
      })
    },
    submitSave() {
      let obj = {
        ...this.formItem,
        createUser : JSON.parse(sessionStorage.getItem('userInfo')).userId
      };
      axios.post("/MPowerMaster/insertMPowerMasterLabel", obj).then((res) => {
        if (res) {
          this.popShow = false;
          this.$Message.success("新增成功");
          this.getData();
        }
      });
    },
    cancelLeaveData() {
      this.popShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.addButton {
  text-align: right;
  padding-bottom: 15px;
  margin-top: -20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/PermissionMaintenance.vue